<div class="container text-center">
    <div class="page-not-found-content">
      <h1>404</h1>
      <p>Page Not Found</p>
      <!-- <button class="btn btn-secondary" (click)="goBack()">Back</button> -->
    </div>
  </div>
  